import { useCallback, useMemo } from 'react';

import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import {
  DATE_PICKER_COMPACT,
  DatePickerInput,
} from '@/components/ui/date-picker-input';
import { formatURLDate } from '@/utils';

type Props = {
  className?: string;
};

export const ChuteSchedulerCalendar = ({ className }: Props) => {
  const { t } = useTranslation();
  const [params, setParams] = useSearchParams();
  const date = useMemo(() => {
    return params.get('date')
      ? new Date(params.get('date') as string)
      : undefined;
  }, [params]);

  const handleDateChange = useCallback(
    (value: Date | null) => {
      const newParams = new URLSearchParams(params);
      if (value) {
        newParams.set('date', formatURLDate(value));
      } else {
        newParams.delete('date');
      }
      setParams(newParams);
    },
    [params, setParams],
  );

  return (
    <div
      className={`${className ? `${className} ` : ''}label-input-group flex flex-col gap-1`}
    >
      <label className="text-sm">{t('common.date')}</label>
      <DatePickerInput
        initialDate={date}
        placeholder="Select Date"
        onChange={handleDateChange}
        className={DATE_PICKER_COMPACT}
      />
    </div>
  );
};
